import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { Typography } from '@workspace/ui/components/Typography';

import { company } from '~/company/Company';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { useGlobal } from '~/hooks/useGlobal';

import { BrandCard } from '../shared/BrandCard';
import { GridView, tileClassNames } from '../shared/GridView';
import type { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';

const CARD_TITLE_CLASS =
  '[font:var(--text-100-medium)] desktop:[font:var(--header-50-medium)]';

const CategoriesGrid2Brand = ({
  category,
  classes,
  priority = false,
}: BlockCommonProps) => {
  const { root: className, titleClassName } = classes || {};
  const { subcategory = [] } = category;
  const { isMobile } = useGlobal();

  const TitleComponent = isMobile
    ? Typography.Header100Medium
    : Typography.Header400Medium;

  return (
    <div
      className={htmlClasses([
        'flex flex-col items-stretch justify-start desktop:gap-20 gap-10',
        className,
      ])}
    >
      {subcategory.map((subCategory, blockIndex) => (
        <div className="w-full" key={subCategory.id}>
          <div className="desktop:mb-10 mb-4 flex flex-row items-end desktop:items-center justify-between">
            <TitleComponent
              as="h3"
              className={htmlClasses([
                'm-0 text-graphic-regular-brand',
                titleClassName,
              ])}
            >
              {subCategory.name}
            </TitleComponent>
            <ViewAllButton link={createCategoryUrl({ id: subCategory.id })} />
          </div>

          <GridView>
            {subCategory.subcategory.map((item, tileIndex) => {
              const tileSize = (company.tileSizeEnabled && item.tileSize) || 1;

              return (
                <BrandCard
                  key={item.id}
                  category={item}
                  tileSize={tileSize}
                  priority={priority && blockIndex === 0 && tileIndex === 0}
                  classes={{
                    tileClassName:
                      tileClassNames[tileSize] ?? tileClassNames[1],
                    titleClassName: CARD_TITLE_CLASS,
                  }}
                />
              );
            })}
          </GridView>
        </div>
      ))}
    </div>
  );
};

export default observer(CategoriesGrid2Brand);
